import(/* webpackMode: "eager" */ "/app/apps/web/src/app/events/[slug]/error.tsx");
